<script lang="ts">
	import { renderAboutParagraph } from '@shared/site-content';

	export let paragraphs: string[] = [];
	export let name = 'Yitzhak B. Solorzano';
</script>

<section id="about" class="section about about-colophon" aria-labelledby="about-heading">
	<div class="container section-grid">
		<div class="section-intro">
			<p class="eyebrow">Author</p>
			<h2 id="about-heading">About</h2>
			<div class="section-rule" aria-hidden="true"></div>
		</div>
		<div class="section-body">
			{#each paragraphs as paragraph}
				<p>{@html renderAboutParagraph(paragraph, name)}</p>
			{/each}
		</div>
	</div>
</section>
